app.service('partnerSubscriptionManager', function(cartManager, callback, console, log, front, broker, modal, loading) {

	function checkboxClick(params) {
		console.log('partnerSubscriptionManager.checkboxClick', parseInt(params.productId), cartManager.getElements());

		if ($.inArray(parseInt(params.productId), cartManager.getElements()) != -1) {
			if (($.inArray((params.partnerSubscription+'|'+params.group), cartManager.getPartnerSubscriptions(params.productId)) != -1)) {
					cartManager.removePartnerSubscription({
						productId: params.productId,
						partnerSubscriptionId: params.partnerSubscription,
						relatedPromotionIdentifier: params.relatedPromotionIdentifier
					});
			} else {
				if (params.checked) {
					cartManager.addPartnerSubscription({
						productId: params.productId,
						partnerSubscriptionId: params.partnerSubscription,
						relatedPromotionIdentifier: params.relatedPromotionIdentifier
					});
				}
			}
		}else{
			cartManager.savePartnerSubscriptions(params);
			checkedCheck(params.productId);
		}
	}
	function checkedCheck(id, init = true){
		console.log('partnerSubscriptionManager.checkedCheck');
		var partnerSubscriptions=[];
		var added=cartManager.getAddedPartnerSubscriptions();
		var saved=cartManager.getPartnerSubscriptions(id);
		if(added && added.length){
			partnerSubscriptions=partnerSubscriptions.concat(added);
		}
		if(saved && saved.length){
			partnerSubscriptions=partnerSubscriptions.concat(saved);
		}
		var $groups=$('.js-show-partner-subscriptions');
		var $checkbox=$('input[name="partnerSubscription"]');
		$groups.removeClass('change-mode');
		//console.log(partnerSubscriptions)
		partnerSubscriptions.forEach(function(n){
			var data=n.split("|");
			if(data[1].length){
				$groups.filter('[data-group='+data[1]+']').addClass('change-mode');
			}
			if(init) {
				$checkbox.filter('[value='+data[0]+']').prop('checked',true);
			}
		});

	}
	function loadModal(product, group, relatedPromotionIdentifier){
		loading.start();
		$.ajax({
			url:'/partner-subscriptions.ltr',
			data: {
				productId: product,
				partnerSubscriptionGroupId: group
			},
			success:function(html){
				loading.stop();
				modal.generate({
					content:html,
					modifier: 'remodal-full-width',
					id:'modal-partner-subscriptions',
					callbackOpen:function(){
						$('input:checkbox[name="partnerSubscription"]').click(function(){
							var id = $(this).val()/1;
							var checked = $(this).is(':checked');
							checkboxClick({
								partnerSubscription: id,
								checked: checked,
								productId: product,
								relatedPromotionIdentifier,
								group: front.page()=='basket'?'':group
							});
							app.logEvent({
								"id": "Uslugi",
								"f03": document.location.href,
								"f04": "Premium Mobile -  Warstwa",
								"f05": "Wybierz - "+$(this).closest('.item').find('.name').first().text().trim()
							});
						});
						$('#modal-partner-subscriptions .remodal-close').click(function(){
							log.event({
								"id": "Uslugi",
								"f03": document.location.href,
								"f04": "Premium Mobile -  Warstwa",
								"f05": "Wróć"
							});
						});
						checkedCheck(product);
					}
				})
			},
			error:function(){
				modal.alert('Błąd pobierania danych');
			}
		});
	}
	function init(){
		$('body').on('click', '.js-show-partner-subscriptions',function(){
			var group = $(this).data('group');
			var product = $(this).data('product');
			var relatedPromotionIdentifier = $(this).data('related-promotion-identifier');
			loadModal(product, group, relatedPromotionIdentifier);
		});

		$('body').on('click', '.js-services-next', function() {
			modal.close();
		});
	}

	return {
		checkedCheck,
		init
	};
});
